import { render, staticRenderFns } from "./ButtonAdd.vue?vue&type=template&id=511c93c4&scoped=true"
import script from "./ButtonAdd.vue?vue&type=script&lang=js"
export * from "./ButtonAdd.vue?vue&type=script&lang=js"
import style0 from "./ButtonAdd.vue?vue&type=style&index=0&id=511c93c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c93c4",
  null
  
)

export default component.exports